(function () {
  const ADDING_TEXT = 'Adding...';
  const ADDED_TEXT = 'Added';
  const processingForms = new WeakSet();

  function isCartAddForm(form) {
    if (!form || form.dataset.dogdadAjaxCart === 'false') return false;
    const action = form.getAttribute('action') || '';
    return (
      form.classList.contains('dogdad-product-form') ||
      form.classList.contains('dogdad-product__form') ||
      /\/cart\/add/i.test(action)
    );
  }

  function getSubmitButton(form, event) {
    const submitter = event.submitter;
    if (submitter instanceof HTMLButtonElement || submitter instanceof HTMLInputElement) return submitter;
    return form.querySelector('[type="submit"], button:not([type])');
  }

  function replaceCartDrawerFromHtml(html) {
    if (!html) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#shopify-section-cart-drawer-section');
    const current = document.querySelector('#shopify-section-cart-drawer-section');
    if (fresh && current) current.replaceWith(fresh);
  }

  async function refreshCartDrawerFallback() {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}?sections=cart-drawer-section`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) return false;

    const sections = await response.json();
    replaceCartDrawerFromHtml(sections['cart-drawer-section']);
    return Boolean(sections['cart-drawer-section']);
  }

  function updateCartBubbleFromDrawer() {
    const drawerCount = document.querySelector('#cart-drawer .theme-drawer__badge')?.textContent?.trim();
    const count = Number(drawerCount || 0);
    if (!Number.isFinite(count)) return;

    document.querySelectorAll('.cart-bubble').forEach((bubble) => {
      bubble.classList.toggle('visually-hidden', count < 1);
    });
    document.querySelectorAll('.cart-bubble__text-count').forEach((node) => {
      node.textContent = count > 99 ? '' : String(count);
      node.classList.toggle('hidden', count < 1);
    });
    document.querySelectorAll('.header-actions__cart-icon').forEach((icon) => {
      icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    });
  }

  async function openCartDrawer() {
    await customElements.whenDefined('theme-drawer').catch(() => {});
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"]');
    if (trigger instanceof HTMLElement) trigger.click();
  }

  async function handleCartAdd(form, button) {
    if (processingForms.has(form)) return;
    processingForms.add(form);

    const originalText = button ? button.textContent : '';

    if (button) {
      button.disabled = true;
      button.textContent = ADDING_TEXT;
    }

    try {
      const formData = new FormData(form);
      formData.set('sections', 'cart-drawer-section');
      formData.set('sections_url', window.Shopify?.routes?.root || '/');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
        credentials: 'same-origin',
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
          throw new Error(error.description || error.message || 'Unable to add item');
      }

      const payload = await response.json();
      if (payload?.sections?.['cart-drawer-section']) {
        replaceCartDrawerFromHtml(payload.sections['cart-drawer-section']);
      } else {
        await refreshCartDrawerFallback();
      }
      updateCartBubbleFromDrawer();
      await openCartDrawer();

      if (button) {
        button.textContent = ADDED_TEXT;
        window.setTimeout(() => {
          button.textContent = originalText || 'Add to cart';
        }, 900);
      }
    } catch (error) {
      console.warn('[dogdad-cart] Add to cart failed', error);
      if (button) button.textContent = 'Try again';
    } finally {
      window.setTimeout(() => {
        processingForms.delete(form);
        if (button) {
          button.disabled = false;
          if (button.textContent === 'Try again') button.textContent = originalText || 'Add to cart';
        }
      }, 900);
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target?.closest('button[type="submit"], button[name="add"], .add-to-cart-button');
      const form = button instanceof HTMLElement ? button.closest('form') : null;
      if (!(form instanceof HTMLFormElement) || !isCartAddForm(form)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      handleCartAdd(form, button);
    },
    true
  );

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !isCartAddForm(form)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const button = getSubmitButton(form, event);
      handleCartAdd(form, button);
    },
    true
  );
})();
